import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  DoubleMaterialitySurveyDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_DOUBLE_MATERIALITY } from "../domain";

import { roleGuard } from "@api";
import { doubleMaterialitySurveysApi } from "@api/services";


const ACTION_GET_SURVEYS = "GET_SURVEYS";

interface CreateSurveyDto {
  year: number;
}

const createSurvey = async (
  dto: CreateSurveyDto,
): Promise<DoubleMaterialitySurveyDto> => {
  const res =
    await doubleMaterialitySurveysApi.doubleMaterialitySurveysControllerCreate(dto);

  return res.data;
};

export const useCreateSurvey = (
  user: UserProfileDto | null,
): {
  createSurvey: (dto: CreateSurveyDto) => Promise<DoubleMaterialitySurveyDto>;
  isPendingCreateSurvey: boolean;
  createSurveyEnabled: boolean;
} => {
  const queryClient = useQueryClient();
  const createSurveyEnabled = roleGuard(user, [UserRole.Owner, UserRole.Manager]);

  const mutation = useMutation({
    mutationFn: (dto: CreateSurveyDto) => createSurvey(dto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_DOUBLE_MATERIALITY, ACTION_GET_SURVEYS],
      });
    },
  });

  return {
    createSurvey: (dto: CreateSurveyDto) => mutation.mutateAsync(dto),
    isPendingCreateSurvey: mutation.isPending,
    createSurveyEnabled,
  };
};
